import React, { Component, Fragment } from "react";

class Footer extends Component {
  state = {
    data: [],
    control: null,
    loaded: false,
  };

  constructor(props) {
    super(props);

    this.createDataList = this.createData.bind(this);
  }

  componentDidMount() {
    this.setState({
      control: this.props.control,
      loaded: true,
      data: this.props.data,
    });
  }

  createData() {
    let output = [];
    this.state.data.map((itm, idx) => {
      output.push(
        <div
          key={idx}
          className="next-update"
          id="next-update-visible"
          style={{ display: "block;" }}
        >
          Τα δωρεάν MB <span className="" rechargepackagetype=""></span> θα
          ανανεωθούν αυτόματα στις
          <span className="white-space-now-wrap">
            {itm.nextBillingDate.component}
          </span>
        </div>
      );
    });
    return (
      <Fragment>
        {output}
        <div className="next-update vat ">
          Τιμές με ΦΠΑ και&nbsp;
          <a href="#terms" className="terms open-lightbox termvat">
            Τέλος Συνδρομητών Κινητής Τηλεφωνίας
          </a>
          &nbsp;10%, όπου αυτό εφαρμόζεται.
        </div>
        <div
          className="next-update"
          id="next-update-invisible"
          style={{ display: "none;" }}
        ></div>
      </Fragment>
    );
  }

  clickMeAccessibilityStatement() {
    window.open('./resources/pdf/Cosmote Accessibility statement - Greek_13.07.2025-MI.pdf', '_blank');
  }


  render() {
    if (this.state.loaded) {
      return (
        <Fragment>
          <div className="footer">
            <div className="hold" style={{display:"flex", flexDirection:"column", justifyContent:"center"}}>
              <a href="#terms" className="terms open-lightbox"
                 style={{ cursor: "pointer", lineHeight:"30px" }}>
                Όροι &amp; Προϋποθέσεις &gt;
              </a>
              <a
                className="terms open-lightbox"
                style={{ cursor: "pointer", lineHeight:"30px" }}
                onClick={(e) => this.clickMeAccessibilityStatement()}
              >
                Δήλωση Προσβασιμότητας &gt;{" "}
              </a>
            </div>
          </div>
        </Fragment>
      );
    } else {
      return "";
    }
  }
}

export default Footer;
